let initialised = false;

export default function () {
    const nuxtApp = useNuxtApp();

    const init = async function () {
        if (initialised) return true;
        if (!import.meta.client) return false;
        await import('leaflet/dist/leaflet.css');
        const L = await import('leaflet');
        nuxtApp.provide('L', L);
        initialised = true;
        return true;
    };

    return {init};
}
